module.exports = "/_next/static/chunks/fonts/close-69423a38781b87f19c4fb6ec4e1f0784.svg";